import {MI} from "../init";
import AbstractSymbol from "./AbstractSymbol";
import {getRandomFloat, getRandomInt} from "../../framework/src/helpers";
import {madnes_key_exist} from "../../framework/src/engine/madnes/madnes_object";

/**
 * @constructor
 * @extends {AbstractSymbol}
 * @param {MadnesObject} sprite
 * @param {number} symbolNum
 * @param {number} reelX
 * @param {number} reelY
 */
export default function SymbolFlask(sprite, symbolNum, reelX, reelY) {
    AbstractSymbol.call(this, sprite, symbolNum, reelX, reelY);

    this._dia = 130;

    /** @type {MadnesTween} */
    this._moveSymbolTween;
    /** @type {MadnesTween} */
    this._rotateSymbolTween;

    this._moveSymbolStopped = true;

    /** @type {MadnesObject} */
    this._spriteSymbol;

    this._spriteSymbolX = 10+4;
    this._spriteSymbolY = 10+4;

    /** @type {MadnesGraphics} */
    this._bubblesMask;

    /** @type {Array<MadnesObject>} */
    this._bubbles = [];

    /** @type {MadnesObject|null} */
    this._winShineObject;

    /** @type {Function|null} */
    this._winAnimResolver;
};

SymbolFlask.prototype = Object.create(AbstractSymbol.prototype);
SymbolFlask.prototype.constructor = SymbolFlask;

SymbolFlask.shineColorK = 0xfd1eb6;
SymbolFlask.shineColorJ = 0x35b5ff;
SymbolFlask.shineColorA = 0xff0030;
SymbolFlask.shineColorQ = 0xc0ff00;

/**
 * @override
 * @returns {number}
 */
SymbolFlask.prototype.getShineColor = function() {

    switch(this.symbolName) {
        case 'symbol_K':
            return SymbolFlask.shineColorK;
        case 'symbol_J':
            return SymbolFlask.shineColorJ;
        case 'symbol_A':
            return SymbolFlask.shineColorA;
        case 'symbol_Q':
            return SymbolFlask.shineColorQ;
    }

    return 0x000000;
};

/**
 * @override
 * @param {number} num
 * @returns {string}
 */
SymbolFlask.getParticleColor = function(num) {

    var symbol = AbstractSymbol.getSymbolByNum(num);

    switch(symbol) {
        case 'symbol_K':
            return "pink";
        case 'symbol_A':
            return "red";
        case 'symbol_Q':
            return "green";
        case 'symbol_J':
        default:
            return "blue";
    }
};

/**
 * @override
 * @returns {undefined}
 */
SymbolFlask.prototype.clear = function() {
    //this.parentSprite.setTexture("symbols_atlas");
    this._clearParentSprite();

    this.shineSymbol = null;
    this.destroyShineAnim();

    this._winShineObject = null;

    this._winAnimResolver = null;

    this._stopBubbles();

    this.removeChilds();
};

SymbolFlask.prototype._getShineName = function() {
    switch(this.symbolName) {
        case "symbol_J":
            return "flask_shine_J";
        case "symbol_A":
            return "flask_shine_A";
        case "symbol_K":
            return "flask_shine_K";
        case "symbol_Q":
            return "flask_shine_Q";
    }

    return "";
};

/**
 * @override
 * @returns {SymbolFlask}
 */
SymbolFlask.prototype.createSymbol = function() {
    this.clear();

    this._spriteSymbol = this.createImage(this._spriteSymbolX, this._spriteSymbolY, "symbols_atlas").setFrameName(this.symbolName).setAnchor(0.5, 0.5);
    this.createImage(0, 0, "symbols_atlas").setFrameName("flask");
    this.shineSymbol = this.createImage(0, 0, "symbols_atlas").setFrameName(this._getShineName()).setBlend("ADD").setScale(1.5, 1.5);
    this.createShineAnim();

    return this;
};

/**
 * @override
 * @returns {AbstractSymbol}
 */
SymbolFlask.prototype.createSimpleSymbol = function() {
    this.clear();

    this._spriteSymbol = this.createImage(this._spriteSymbolX, this._spriteSymbolY, "symbols_atlas").setFrameName(this.symbolName).setAnchor(0.5, 0.5);
    this.createImage(0, 0, "symbols_atlas").setFrameName("flask");
    this.shineSymbol = this.createImage(0, 0, "symbols_atlas").setFrameName(this._getShineName()).setBlend("ADD").setScale(1.5, 1.5);

    return this;
};

/**
 * @override
 * @returns {undefined}
 */
SymbolFlask.prototype.createStandAnim = function() {
    for(var i = 0; i <= 5; i++) {
        this._bubbles[i] = this.createImage(0, 0, "symbols_atlas").setFrameName("bubble").setVisible(false); //.addMask(this._bubblesMask);
    }
};

/**
 * @override
 * @returns {undefined}
 */
SymbolFlask.prototype.playStandAnim = function() {
    this._moveSymbolStopped = false;
    this._playBubbles();
    this._moveSymbol();
    this._rotateSymbol();
};

/**
 * @override
 * @returns {undefined}
 */
SymbolFlask.prototype.stopStandAnim = function() {
    this._stopBubbles();
    this._moveSymbolStop();
    this._rotateSymbolStop();
};

SymbolFlask.prototype.stopOnWinAnim = function() {
    this._moveSymbolStop();
    this._rotateSymbolStop();

    this._spriteSymbol.setPos(this._spriteSymbolX, this._spriteSymbolY);
    this._spriteSymbol.setAngle(0);
};

SymbolFlask.prototype.playOnWinAnim = function() {
    this._moveSymbol();
    this._rotateSymbol();
};

SymbolFlask.prototype._playBubbles = function() {
    for(var i = 0; i < this._bubbles.length; i++) {
        this._bubbles[i].setVisible(true);
        this._bubbleAnim(this._bubbles[i]);
    }
};

SymbolFlask.prototype._stopBubbles = function() {
    for(var i = 0; i < this._bubbles.length; i++) {
        if(this._bubbles[i]['_bubbleTween']) {
            this._bubbles[i]['_bubbleTween'].stop();
        }
        /*if(this._bubbles[i]._bubbleAlphaTween) {
            this._bubbles[i]._bubbleAlphaTween.stop();
        }*/
    }
};

SymbolFlask.prototype._bubbleAnim = function(bubble) {

    if(!AbstractSymbol.spriteExists(bubble)) return;

    /** @type {SymbolFlask} */
    var _self = this;

    var data = this._getBubbleData();
    bubble.setScale(data['coef'], data['coef']);
    //bubble.setAlpha(0);

    bubble.setPos(data['x'], data['y'], true);
    //var delay = getRandomInt(0, 500);

    /*bubble._bubbleAlphaTween = MI.addTween().to(bubble, { 'alpha': 1 }, {
        'duration': 300,
        //'delay': delay
    });*/

    bubble['_bubbleTween'] = MI.addTween().to(bubble, { 'y': data['y'] - data['path'] }, {
        //'delay': delay,
        'duration': 1500 * (1 - data['coef']),
        /*'onStart': function() {
            bubble.setAlpha(1);
        },*/
        'callback': function() {
            _self._bubbleAnim(bubble);
        }
    });
};

SymbolFlask.prototype._getCirclePosition = function(radius) {
    var t = Math.PI + Math.PI * getRandomFloat(0.1, 0.9);
    return {
        'x': Math.cos(t) * radius,
        'y': Math.sin(t) * radius
    };
};

SymbolFlask.prototype._getBubbleData = function() {

    var cpos = this._getCirclePosition(this._dia / 2);
    var fullpath = cpos['y'] * -2 - 5;
    var path = fullpath * getRandomFloat(0.5, 1);
    var offset = (fullpath - path) * Math.random();
    var y = cpos['y'] * -1 - offset;

    return {
        'x': cpos['x'] + 10,
        'y': y,
        'path': path,
        'coef': getRandomFloat(0.2, 0.6)
    };
};

SymbolFlask.prototype._moveSymbol = function() {

    /** @type {SymbolFlask} */
    var _self = this;

    if(this._moveSymbolStopped) {
        return;
    }

    this._moveSymbolStopped = false;
    var randCircle = MI.getCircleRandPoint(1);

    this._moveSymbolTween = MI.addTween().to(this._spriteSymbol,
        { 'x': randCircle['x'], 'y': randCircle['y'] },
        {
            'duration': 10000, //getRandomInt(8000, 10000),
            'yoyo': true,
            //'count': -1,
            'callback': function() {

                if(_self._moveSymbolStopped) {
                    _self._moveSymbolStop();
                    return;
                }

                _self._moveSymbol();
            }
        }
    );
};

SymbolFlask.prototype._moveSymbolStop = function() {
    this._moveSymbolStopped = true;
    this._moveSymbolTween && this._moveSymbolTween.stop();
};

SymbolFlask.prototype._moveSymbolPause = function() {
    this._moveSymbolTween && this._moveSymbolTween.pause();
};

SymbolFlask.prototype._moveSymbolResume = function() {
    this._moveSymbolTween && this._moveSymbolTween.resume();
};

SymbolFlask.prototype._rotateSymbol = function() {

    /** @type {SymbolFlask} */
    var _self = this;

    if(this._moveSymbolStopped) {
        return;
    }

    this._rotateSymbolTween = MI.addTween().to(this._spriteSymbol,
        { 'angle': getRandomInt(-8, 8) },
        {
            'duration': getRandomInt(6000, 14000),
            //'count': -1,
            'callback': function() {

                if(_self._moveSymbolStopped) {
                    _self._rotateSymbolStop();
                    return;
                }

                _self._rotateSymbol();
            }
        }
    );
};

SymbolFlask.prototype._rotateSymbolStop = function() {
    this._rotateSymbolTween && this._rotateSymbolTween.stop();
};

SymbolFlask.prototype._rotateSymbolPause = function() {
    this._rotateSymbolTween && this._rotateSymbolTween.pause();
};

SymbolFlask.prototype._rotateSymbolResume = function() {
    this._rotateSymbolTween && this._rotateSymbolTween.resume();
};

SymbolFlask.prototype.fadeOutStandAnim = function() {

    var _self = this;

    var obj = { 'alpha': 1 };
    MI.addTween().to(obj, { 'alpha': 1 }, {
        'duration': 200,
        'update': function() {
            for(var i = 0; i < _self._bubbles.length; i++) {
                _self._bubbles[i].setAlpha(obj['alpha']);
            }
        },
        'callback': function() {
            _self._stopBubbles();
            for(var i = 0; i < _self._bubbles.length; i++) {
                _self._bubbles[i].destroy();
            }
            _self._bubbles.length = 0;

            _self._moveSymbolStop();
            _self._rotateSymbolStop();
        }
    });
};

SymbolFlask.prototype.fadeInStandAnim = function() {
    this.createStandAnim();
    this._playBubbles();

    this._moveSymbolStopped = false;
    this._moveSymbol();
    this._rotateSymbol();
};

/**
 * @override
 * @returns {SymbolFlask}
 */
SymbolFlask.prototype.createWinSymbol = function() {
    this.createSymbol();

    this._winShineObject = this.createImage(-5, 0, this.symbolName + "_atlas")
        .setBlend("ADD").setScale(2, 2).setVisible(false).setAlpha(1);
    this._winShineObject.createAnims();
    this._winShineObject.anims.add("win", MI.generateFrameNames(this.symbolName + "_", 0, 19, "", 5));

    this._winShineObject.anims.addOnComplete(function() {
        this._winAnimResolver();
    }.bind(this));

    return this;
};

/**
 * @returns {Promise}
 */
SymbolFlask.prototype.playWinAnim = function() {
    return new Promise(function(res) {

        this._winAnimResolver = res;

        this._winShineObject.setVisible(true);
        this._winShineObject.anims.play("win", 40);

    }.bind(this));
};

SymbolFlask.prototype.stopWinAnim = function() {
    this._winAnimResolver = null;
    this._winShineObject.anims && this._winShineObject.anims.stop();
};

SymbolFlask.prototype.destroyWinAnim = function() {
    this.stopWinAnim();
    this._winShineObject.destroy();
};